import { CommitteeEmployee } from "../../../models/Committee";

export const replaceEmployeeInTableData = (
  employees: CommitteeEmployee[],
  updatedEmployee: CommitteeEmployee
) => {
  return employees.map((emp) =>
    emp.rowKeyId === updatedEmployee.rowKeyId ? updatedEmployee : emp
  );
};
